export default "__VITE_ASSET__ChtBT$$R__"